import { render, staticRenderFns } from "@/modules/Account/templates/accounts-with-cases.html?vue&type=template&id=38353fbc&scoped=true&"
import script from "@/modules/Account/scripts/accounts-with-cases.ts?vue&type=script&lang=js&"
export * from "@/modules/Account/scripts/accounts-with-cases.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Account/styles/accounts-with-cases.scss?vue&type=style&index=0&id=38353fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38353fbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VImg,VSkeletonLoader,VTooltip})
